export default "__VITE_ASSET__a7088d2e__"